const defaultValues = {
  emptyString: '',
  emptyInt: 0,
  singleSpace: ' ',
}

export default defaultValues
